import { FLEET_CHARGING_SESSION_REPORT, DOWNLOAD_FLEET_CHARGING_SESSION_REPORT } from 'actions/dataReport';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import Footer from 'components/general/Footer';
import ReactPagination from 'components/general/ReactPagination';
import AdminHeader from 'components/header';
import Button from 'components/inputs/Button';
import Card from 'components/inputs/Card';
import DateTimePicker from 'components/inputs/DateTimePicker';
import LayoutContainer from 'components/layout/LayoutContainer';
import fileDownload from 'js-file-download';
import * as _ from 'lodash';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsDownload } from 'react-icons/bs';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'components/inputs/Select';
import { FETCH_USER } from 'actions/user';

const FleetChargingSessionReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(moment(new Date()).startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
  const [selectedFleetOwner, setSelectedFleetOwner] = useState(null);
  const [fleetOwners, setFleetOwners] = useState([]);

  const reportTableHeader = [
    {
      id: 'srNo',
      header: t('fleetChargingSessionReport.srNo'),
    },
    {
      id: 'state',
      header: t('fleetChargingSessionReport.state'),
    },
    {
      id: 'userName',
      header: t('fleetChargingSessionReport.userName'),
    },
    {
      id: 'mobileNumber',
      header: t('fleetChargingSessionReport.mobileNumber'),
    },
    {
      id: 'fleetOwner',
      header: t('fleetChargingSessionReport.fleetOwner'),
    },
    {
      id: 'stationName',
      header: t('fleetChargingSessionReport.stationName'),
    },
    {
      id: 'chargerName',
      header: t('fleetChargingSessionReport.chargerName'),
    },
    {
      id: 'unitsConsumed',
      header: t('fleetChargingSessionReport.unitsConsumed'),
    },
    {
      id: 'vehicleNumber',
      header: t('fleetChargingSessionReport.vehicleNumber'),
    },
    {
      id: 'sessionStartDate',
      header: t('fleetChargingSessionReport.sessionStartDate'),
    },
    {
      id: 'sessionStopDate',
      header: t('fleetChargingSessionReport.sessionStopDate'),
    },
    {
      id: 'idTag',
      header: t('fleetChargingSessionReport.idTag'),
    },
    {
      id: 'transactionId',
      header: t('fleetChargingSessionReport.transactionId'),
    },
    {
      id: 'duration',
      header: t('fleetChargingSessionReport.duration'),
    },
    {
      id: 'serviceCharge',
      header: t('fleetChargingSessionReport.serviceCharge'),
    },
    {
      id: 'totalAmount',
      header: t('fleetChargingSessionReport.totalAmount'),
    },
    {
      id: 'pricePerUnit',
      header: t('fleetChargingSessionReport.pricePerUnit'),
    },
    {
      id: 'CGST',
      header: t('fleetChargingSessionReport.CGST'),
    },
    {
      id: 'SGST',
      header: t('fleetChargingSessionReport.SGST'),
    },
    {
      id: 'IGST',
      header: t('fleetChargingSessionReport.IGST'),
    },
  ];
  const fleetOwnerFilterDropdownStyle = { minWidth: '200px' };

  const {
    fleetChargingSessions,
    isLoading: isLoader,
    page,
    total: totalData,
    limit,
    totalPages,
  } = useSelector((state) => state.fleetChargingSessionReport);

  const { page: currentFleetOwnerPage, totalPages: totalFleetOwnerPages } = useSelector((state) => state.user);
  const isFleetOwnerLoading = useSelector((state) => state.user.isLoading);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserName = _.get(profileData, 'name', '');
  const dateTimeFormat = 'DD-MM-YYYY HH:mm:ss';

  const formatTime = (ms) => {
    if (ms === '-') return `-`;
    const duration = moment.duration(ms);
    const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const fetchFleetOwners = useCallback((value) => {
    const data = {
      ...value,
      limit: 999,
      role: 'fleet_owner',
    };
    dispatch({
      type: FETCH_USER.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          res.data.page === 1 ? setFleetOwners(res.data.results) : setFleetOwners((prevVal) => [...prevVal, ...res.data.results]);
          //   res.data.page === 1 ? (fleetOwners.current = [...res.data.results]) : (fleetOwners.current = [...fleetOwners.current, ...res.data.results]);
          // onCloseAdvanceFilterPopup();
        }
      },
    });
  }, []);

  const fleetChargingSessionReport = useCallback(
    (value) => {
      const data = {
        ...value,
        from: moment(startDate).toISOString(),
        to: moment(endDate).toISOString(),
      };
      dispatch({
        type: FLEET_CHARGING_SESSION_REPORT.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            // onCloseAdvanceFilterPopup();
          }
        },
      });
    },
    [startDate, endDate]
  );

  const downloadFleetChargingSessionReport = useCallback(() => {
    const data = {
      excel: true,
      fleetOwner: selectedFleetOwner,
      from: moment(startDate).toISOString(),
      to: moment(endDate).toISOString(),
    };

    dispatch({
      type: DOWNLOAD_FLEET_CHARGING_SESSION_REPORT.REQUEST,
      payload: data,
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'Fleet Charging Session Report'}.xlsx`);
          }
        }
      },
    });
  }, [startDate, endDate, selectedFleetOwner]);

  const dateFilter = useCallback(() => {
    const filterDateData = {
      from: moment(startDate).utc(),
      to: moment(endDate).utc(),
      fleetOwner: selectedFleetOwner,
    };
    fleetChargingSessionReport(filterDateData);
  }, [startDate, endDate, selectedFleetOwner]);

  const handlePageClick = useCallback(
    (page) => {
      if (startDate && endDate) {
        const data = {
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
          page: page.selected + 1,
          fleetOwner: selectedFleetOwner,
        };
        fleetChargingSessionReport(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        fleetChargingSessionReport(data);
      }
    },
    [startDate, endDate, selectedFleetOwner]
  );

  const downloadFile = () => {
    downloadFleetChargingSessionReport();
  };

  const TableLoader = () => {
    return <Skeleton height={15} width={100} />;
  };

  const TableHeader = () => {
    return (
      <thead>
        <tr>
          {reportTableHeader.map((item) => {
            return (
              <th key={item.id}>
                <div>
                  <span>{isLoader ? <TableLoader /> : item.header}</span>
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const TableBody = () => {
    return (
      <tbody>
        {isLoader ? (
          <tr>
            <td colSpan={9} className="border-0">
              <div className="loader--block">
                <TableLoader />
              </div>
            </td>
          </tr>
        ) : _.isEmpty(fleetChargingSessions) ? (
          <tr>
            <td colSpan={10} className="border-0">
              <div className="empty-data-block">No Fleet Charging Sessions Found</div>
            </td>
          </tr>
        ) : (
          !(isLoader || _.isUndefined(isLoader)) &&
          _.map(fleetChargingSessions, (item, key) => {
            const serial_num = limit * (page - 1) + key;
            return (
              <tr key={item.transaction_id}>
                <td>{isLoader ? <TableLoader /> : serial_num + 1}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'state', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'user_name', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'mobile_number', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'fleet_owner', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'station', '-')}</td>
                <td>{isLoader ? <TableLoader /> : `${_.get(item, 'chargerId', '-')} (${_.get(item, 'gun_name', '-')})`}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'units_consumed', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'vehicle', '-')}</td>
                <td>
                  {isLoader ? (
                    <TableLoader />
                  ) : (
                    (moment
                      .utc(_.get(item, 'session_start', '-'))
                      .tz('Asia/Kolkata')
                      .format(dateTimeFormat) ?? '-')
                  )}
                </td>
                <td>
                  {isLoader ? (
                    <TableLoader />
                  ) : (
                    (moment
                      .utc(_.get(item, 'session_stop', '-'))
                      .tz('Asia/Kolkata')
                      .format(dateTimeFormat) ?? '-')
                  )}
                </td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'idTag', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'transaction_id', '-')}</td>
                <td>{isLoader ? <TableLoader /> : formatTime(_.get(item, 'duration', '-'))}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'service_charge', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'total_amount', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item, 'price_per_unit', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item?.gst, 'CGST', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item?.gst, 'SGST', '-')}</td>
                <td>{isLoader ? <TableLoader /> : _.get(item?.gst, 'IGST', '-')}</td>
              </tr>
            );
          })
        )}
      </tbody>
    );
  };

  const ReportHeader = () => {
    return (
      <div className="data-report__box">
        <Row className="data-report__row">
          <Col xl={'auto'} md={'auto'}>
            <div style={{ display: 'flex', marginTop: '0.7rem', fontWeight: 'bold' }}>{t('fleetChargingSessionReport.title')}</div>
          </Col>
          <Col xl={'auto'} md={'auto'}>
            <div className="data-report-date_picker">
              <DateTimePicker
                onChangeOfStartDate={(item) => setStartDate(item)}
                onChangeOfEndDate={(item) => setEndDate(item)}
                initialValueOfStartDate={startDate}
                initialValueOfEndDate={endDate}
              />
            </div>
          </Col>
          <Col xl={'auto'} md={'auto'}>
            <div style={fleetOwnerFilterDropdownStyle}>
              <Select
                options={_.map(fleetOwners, (item) => {
                  return { label: item.name, value: item.name };
                })}
                isLoading={isFleetOwnerLoading}
                className="filter-select-box"
                placeholder={t('placeHolder.selectFleetOwner')}
                name="fleetOwner"
                value={selectedFleetOwner}
                onMenuScrollDown={true}
                getDataOnScrollDown={fetchFleetOwners}
                page={currentFleetOwnerPage}
                totalPage={totalFleetOwnerPages}
                onChange={(val) => {
                  setSelectedFleetOwner(val);
                }}
              />
            </div>
          </Col>
          <Col xl={'auto'} md={'auto'}>
            <div className="report-search-box" onClick={dateFilter}>
              <Button className="report-search-button">Search</Button>
            </div>
          </Col>

          <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
            {isLoading ? (
              <div className="loader--block">
                <Spinner as="span" animation="border" size="sm" role="status" />
              </div>
            ) : (
              <div className="report-excel-icon">
                <BsDownload title="Download" size={28} color={'#3c7cdd'} />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  const ReportTable = () => {
    return (
      <div className="data-report__table">
        <div className="table-responsive">
          <table className="record-list-table" id="table-to-xls">
            <TableHeader />
            <TableBody />
          </table>
        </div>
      </div>
    );
  };

  useEffect(() => {
    fleetChargingSessionReport();
    fetchFleetOwners();
  }, []);

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.fleetChargingSessions')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="data-report--main">
              <Card>
                <div className="data-report__inner">
                  <ReportHeader />
                  <ReportTable />
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(fleetChargingSessions) && (
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>
    </>
  );
};

export default FleetChargingSessionReport;
